import analytics from '@segment/analytics.js-core';

export enum Category {
	NavBox = 'NavBox',
	SocialLink = 'SocialLink',
	RequestDemoError = 'RequestDemoError',
	VideoPlay = 'VideoPlay',
}

export class GoogleAnalyticsUtils {
	static ReportEvent = (category: Category, action: string, value?: number) => {
		if (process.env.NODE_ENV === 'development') {
			return;
		}

		if (value !== undefined) {
			analytics.track(`${category}.${action}`, { value });
		} else {
			analytics.track(`${category}.${action}`, {});
		}
	};
}
